<mat-divider style="margin-top: 5px;"></mat-divider>
<div class="animated fadeIn fast" style="margin-top: 20px;">

  <div class="example-header">

    <div class="row">
      <div class="col-2 font-text">
        <mat-form-field>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtro">
        </mat-form-field>
      </div>

      <div class="col-10">
        <div *ngIf="listPois">
          <button
            mat-stroked-button
            (click)="openDialog()"
            class="button-move font-text"
            [disabled]="!eventChecked"
            style="float: right;"
          >
            Mover pois seleccionados
          </button>
        </div>
        <div *ngIf="listPois">
          <button
          mat-stroked-button
            (click)="openMassDelete()"
            class="button-move font-text"
            [disabled]="!eventChecked"
            style="float: right;"
          >
              Borrar Pois Seleccionados
              <mat-icon>delete_sweep</mat-icon>
          </button>
        </div>
        <div *ngIf="listPois">
          <button
            mat-stroked-button
              (click)="removeAllPois()"
              class="button-move font-text"
              [disabled]="datasourceDataLenght==0"
              style="float: right;"
            >
                Borrar todos los Pois
                <mat-icon>delete_sweep</mat-icon>
            </button>
        </div>
      </div>
    </div>
    <div class="mat-elevation-z6" *ngIf="loadTable">
      <table mat-table [dataSource]="dataRoot || dataPois || dataSource" class="full-width-table" matSort aria-label="Elements" style="box-shadow: none;">

        <ng-container matColumnDef="checkbox_cambio">
          <th id="0" mat-header-cell *matHeaderCellDef mat-sort-header (click)="setAllCheckbox(selectAllCheckbox)" class="title-standar">Seleccionar página</th>
            <td header="0" mat-cell *matCellDef="let row">
              <mat-checkbox
                class="example-margin"
                (change)="showOptions($event,row.id)"
                [checked]="selectAllCheckbox"
              >
              </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th id="1" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Id</th>
          <td header="1" mat-cell *matCellDef="let row;">{{row.id}}</td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th id="2" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Nombre</th>
          <td header="2" mat-cell *matCellDef="let row">
            <div class="mat-fit">
              <img [src]="row.icons.d32_url" class="icon" alt="category icon" (error)="iconErrorHandler($event)"/>
              <img [src]="row.markers.d32_url" class="marker" alt="category marker" (error)="markerErrorHandler($event)"/>
              {{row.nombre}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="nombre_pois">
          <th id="3" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Nombre</th>
          <td header="3" mat-cell *matCellDef="let row">
            <div class="mat-fit">
              {{row.nombre}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="parent">
          <th id="4" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Parent ID</th>
          <td header="4" mat-cell *matCellDef="let row">{{row.parentId}}</td>
        </ng-container>

        <ng-container matColumnDef="pois_count">
          <th id="5" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Pois</th>
          <td header="5" mat-cell *matCellDef="let row">{{row.poisCount}}</td>
        </ng-container>

        <ng-container matColumnDef="fuente">
          <th id="6" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Fuente</th>
          <td header="6" mat-cell *matCellDef="let row">{{row.fuente}}</td>
        </ng-container>

        <ng-container matColumnDef="red">
          <th id="7" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Red</th>
          <td header="7" mat-cell *matCellDef="let row">
            {{ row.red ? 'Habilitado' : 'Deshabilitado' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th id="8" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Creado en</th>
          <td header="8" mat-cell *matCellDef="let row">{{row.createdAt?.slice(0, 10) ?? ''}}</td>
        </ng-container>

        <ng-container matColumnDef="direccion_completa">
          <th id="9" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Dirección</th>
          <td header="9" mat-cell *matCellDef="let row">{{row.direccionCompleta}}</td>
        </ng-container>

        <ng-container matColumnDef="coords">
          <th id="10" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Coordenadas</th>
          <td header="10" mat-cell *matCellDef="let row">{{row.lat}} , {{row.lng}}</td>
        </ng-container>

        <ng-container matColumnDef="cantidad">
          <th id="11" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Cantidad</th>
          <td header="11" mat-cell *matCellDef="let row">{{row.cantidad}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th id="12" mat-header-cell *matHeaderCellDef mat-sort-header class="title-standar">Acciones</th>
          <td header="12" mat-cell *matCellDef="let row" class="td-actions">
            <span class="action-buttons">
              <a aria-label="View" [routerLink]="[routerLink,categories,row.id]" matTooltip="Visualizar" (onclick)="loadData()">
                <mat-icon class="icon-view">visibility</mat-icon>
              </a>
              <a aria-label="Editar" [routerLink]="[listPois ? routerLinkEdit : '/category',row.id,'edit']" matTooltip="Editar" (click)="setDataToEdit(row)">
                <mat-icon class="icon-edit">edit</mat-icon>
              </a>
              <a aria-label="Delete" matTooltip="Eliminar" (click)="openDialogToDelete(row)">
                <mat-icon class="icon-delete">delete</mat-icon>
              </a>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #paginator
        [length]="datasourceDataLenght"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButton
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>